import  React from "react";
import { connect } from "react-redux";
import {Card, CardBody, Col, Container, Row} from "shards-react";
import PageTitle from "../../components/common/PageTitle";
import { requestPractitioners } from "../../actions/practitioners.action";
import {
    InputGroup,
    InputGroupAddon,
    InputGroupText,
    DatePicker
} from "shards-react";

import Select from 'react-select';
import { registerLocale } from 'react-datepicker';
import moment from 'moment';
import fr from 'date-fns/locale/fr';
import {requestAllStatistics} from "../../actions/statistics.action";
import { Doughnut } from 'react-chartjs-2';

registerLocale("fr", fr);

class Statistics extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            startDate: null,
            endDate: null,
            uuid: 0,
            value: "",
            colStat: 3
        };
        this.props.loadData();
        this.props.loadStats(this.state);
        this.handleStartDateChange = this.handleStartDateChange.bind(this);
        this.handleEndDateChange = this.handleEndDateChange.bind(this);
        this.handlePractitionerChange = this.handlePractitionerChange.bind(this);
    }

    handlePractitionerChange(value, {action}) {
        let uuid = 0;
        let col = 3;
        if (action !== 'clear') {
            uuid = value.uuid;
            col = 4;
        }
        this.setState({
            value: value,
            uuid: uuid,
            colStat: col
        }, () => this.props.loadStats(this.state));
    }

    handleStartDateChange(value) {
        let date = null;
        if (value !== null) {
            date = moment(value).format('YYYY-MM-DD');
        }
        this.setState({
            startDate: date
        },
        () => this.props.loadStats(this.state));
    }

    handleEndDateChange(value) {
        let date = null;
        if (value !== null) {
            date = moment(value).format('YYYY-MM-DD');
        }
        this.setState({
            endDate: date
        },
        () => this.props.loadStats(this.state));
    }

    getPercentagePrescription() {
        let prescription = this.props.statistics.data.prescription;
        let encounters = this.props.statistics.data.consultations;
        if (prescription === 0) {
            return 0;
        }
        return Math.floor((prescription / encounters) * 100);
    }

    getSalary() {
        let salary = this.props.statistics.data.salary;
        if (salary === null) {
            salary = 0;
        }
        return salary;
    }

    getDataSatisfactionPractitioner() {
        let data = this.props.statistics.data;
        return [data.satisfaction_positive_practitioner, data.satisfaction_negative_practitioner, data.satisfaction_null_practitioner]
    }
    getLegendSatisfactionPractitioner(value) {
        let data = this.props.statistics.data;
        let total = data.satisfaction_positive_practitioner + data.satisfaction_negative_practitioner + data.satisfaction_null_practitioner;
        return Math.floor((value / total) * 100);
    }

    getLegendSatisfactionPatient(value) {
        let data = this.props.statistics.data;
        let total = data.satisfaction_positive_patient + data.satisfaction_negative_patient + data.satisfaction_null_patient;
        return Math.floor((value / total) * 100);
    }

    getDataSatisfactionPatient() {
        let data = this.props.statistics.data;
        return [data.satisfaction_positive_patient, data.satisfaction_negative_patient, data.satisfaction_null_patient]
    }

    render() {
        return (
            <Container fluid className="main-content-container px-4">
                <Row noGutters className="page-header py-4">
                    <PageTitle title="Statistiques" subtitle="statistiques" className="text-sm-left mb-3"/>
                </Row>

                {(this.props.practitioners.fetching || this.props.statistics.fetching) ? (
                    <div className="flex-center">
                        <div className="text-center d-block">
                            <div className="spinner-border" role="status">
                                <span className="sr-only">Loading...</span>
                            </div>
                        </div>
                    </div>
                ) : (
                <Row>
                    <Col sm="12">
                        <Row>
                            <Col sm="3">
                                <Select
                                    isClearable={true}
                                    value={this.state.value}
                                    onChange={ this.handlePractitionerChange }
                                    options={ Array.isArray(this.props.practitioners.data) ? (this.props.practitioners.data ) : ( [] ) }
                                    getOptionLabel={(option) => option.lastname + ' ' + option.firstname}
                                    getOptionValue={(option) => option.uuid}
                                />
                            </Col>
                            <Col sm="9">
                                <InputGroup className="d-flex my-auto date-range justify-content-end">
                                    <DatePicker
                                        locale='fr'
                                        size="sm"
                                        selected={this.state.startDate}
                                        onChange={this.handleStartDateChange}
                                        placeholderText="Date de départ"
                                        className="text-center"
                                        dateFormat="dd/mm/yyyy"
                                        dropdownMode="select"
                                        isClearable={true}
                                    />
                                    <DatePicker
                                        locale='fr'
                                        size="sm"
                                        selected={this.state.endDate}
                                        onChange={this.handleEndDateChange}
                                        placeholderText="Date de fin"
                                        className="text-center"
                                        dateFormat="dd/mm/yyyy"
                                        dropdownMode="select"
                                        isClearable={true}
                                    />
                                    <InputGroupAddon type="append">
                                        <InputGroupText>
                                            <i className="material-icons">&#xE916;</i>
                                        </InputGroupText>
                                    </InputGroupAddon>
                                </InputGroup>
                            </Col>
                        </Row>
                        <Row className="mt-4 header-statistiques">
                            {this.state.uuid === 0 && (
                                <Col sm={this.state.colStat} className="unique-stat">
                                    <i className="material-icons">group</i>
                                    <span>{this.props.statistics.data.actifs_practitioners +" / "+ this.props.statistics.data.all_practitioners}</span>
                                    <h6>Médecins actifs / Inactifs</h6>
                                </Col>
                            )}
                                <Col sm={this.state.colStat} className="unique-stat">
                                    <i className="material-icons material-icons-outlined">voice_chat</i>
                                    <span>{this.props.statistics.data.consultations}</span>
                                    <h6>Consultations</h6>
                                </Col>

                                <Col sm={this.state.colStat} className="unique-stat">
                                    <i className="material-icons">insert_drive_file</i>
                                    <span>{this.getPercentagePrescription()} %</span>
                                    <h6>Taux de préscriptions</h6>
                                </Col>

                                <Col sm={this.state.colStat} className="unique-stat">
                                    <i className="material-icons">euro_symbol</i>
                                    <span>{this.getSalary()}</span>
                                    <h6>Somme perçue</h6>
                                </Col>
                        </Row>
                        {this.props.statistics.data.consultations > 0 && (
                            <Row className="pt-4 pb-4">
                            <Col sm="5">
                                <Card>
                                    <CardBody className="d-flex px-3">
                                        <Col sm={4} className="satisfaction-chart">
                                            <h6> Satisfaction praticien</h6>

                                            <div className="positive"><p>Satisfait</p><strong>{this.getLegendSatisfactionPractitioner(this.props.statistics.data.satisfaction_positive_practitioner)}%</strong></div>
                                            <div className="negative"><p>Insatisfait</p><strong>{this.getLegendSatisfactionPractitioner(this.props.statistics.data.satisfaction_negative_practitioner)}%</strong></div>
                                            <div className="abscence"><p>N/C </p><strong>{this.getLegendSatisfactionPractitioner(this.props.statistics.data.satisfaction_null_practitioner)}%</strong></div>
                                        </Col>
                                        <Col sm={8} className="satisfaction-chart">
                                        <Doughnut
                                                data={{
                                                    labels: ["Satisfait", "Soucis", "Absence"],
                                                    datasets: [{
                                                        data: this.getDataSatisfactionPractitioner(),
                                                        backgroundColor: ['rgb(87, 202, 133)', 'rgb(255, 118, 118)', 'rgb(118, 118, 118)'],
                                                    }]
                                                }}
                                                options={{
                                                    cutoutPercentage: 80,
                                                    legend: {
                                                        display: false,
                                                    }
                                                }}
                                                height={'250vh'}
                                            />
                                        </Col>
                                    </CardBody>
                                </Card>
                            </Col>
                            <Col sm="5">
                                <Card className="cardStat">
                                    <CardBody className="d-flex px-3">
                                        <Col sm={4} className="satisfaction-chart">
                                            <h6> Satisfaction patient</h6>

                                            <div className="positive"><p>Satisfait</p><strong>{this.getLegendSatisfactionPatient(this.props.statistics.data.satisfaction_positive_patient)}%</strong></div>
                                            <div className="negative"><p>Insatisfait</p><strong>{this.getLegendSatisfactionPatient(this.props.statistics.data.satisfaction_negative_patient)}%</strong></div>
                                            <div className="abscence"><p>N/C </p><strong>{this.getLegendSatisfactionPatient(this.props.statistics.data.satisfaction_null_patient)}%</strong></div>
                                        </Col>
                                        <Col sm={8} className="satisfaction-chart">
                                            <Doughnut
                                                data={{
                                                    labels: ["Satisfait", "Insatisfait", "N/C"],
                                                    datasets: [{
                                                        data: this.getDataSatisfactionPatient(),
                                                        backgroundColor: ['rgb(87, 202, 133)', 'rgb(255, 118, 118)', 'rgb(118, 118, 118)'],
                                                    }]
                                                }}
                                                options={{
                                                    cutoutPercentage: 80,
                                                    legend: {
                                                        display: false,
                                                    }
                                                }}
                                                height={'250vh'}
                                            />
                                        </Col>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                        )}
                    </Col>
                </Row>
                    )}
            </Container>
        );
    }
}


function mapStateToProps(state) {
    return {
        practitioners: state['practitioners'],
        statistics: state['statistics']
    };
}

const mapDispatchToProps = dispatch => ({
    loadData: () => dispatch(requestPractitioners()),
    loadStats: (e) => dispatch(requestAllStatistics(e))
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Statistics);


// WEBPACK FOOTER //
// ./src/views/Statistics/Statistics.js